import apiClient from '@/services/axios'
import utilities from '@/services/utilities'

export async function getNotifications() {
	return new Promise((resolve, reject) => {
		return apiClient
			.get('/notifications/supplies')
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function deleteNotifications(id) {
	return new Promise((resolve, reject) => {
		return apiClient
			.delete(`/notifications/${id}`)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}
